module.exports = __webpack_public_path__ + "static/media/tip_cat_stethoscope_fr.4c378e77.png";